import React, { useState } from 'react'
import { ReviewContainerEl } from '../elements'
import { H5 } from '../../../../../../../../../../../../Styles/typography'
import Button from '../../../../../../../../../../../../Components/Buttons/Button'
import AddReview from './addReview'
import Review from './review'
import ReviewStore from '../store/ReviewStore'
import ComponentLoader from '../../../../../../../../../../../../Components/Loading/ComponentLoader'

function ReviewList() {
  const [newReview, setNewReview] = useState(false)

  const {
    reviews,
    loading,
    loadFailed,
    user,
    userType,
  } = ReviewStore.useContainer()

  const canAddReview =
    Boolean(reviews?.find(({ userId }) => userId === user.id)) &&
    userType === 'Enrolled'

  return (
    <ComponentLoader loading={loading} loadFailed={loadFailed}>
      <ReviewContainerEl>
        {canAddReview && !newReview && (
          <Button
            onClick={() => setNewReview(true)}
            type='primary'
            name={'Add Review'}
            requiresLogin
          />
        )}
        {/* {addReview && <AddReview />} */}
        {newReview && <AddReview />}
        {reviews?.length === 0 ? (
          <>
            <div className='illustration' />
            <H5>Take the course and be the first to post a review!</H5>
          </>
        ) : (
          reviews
            ?.sort((a, b) => Number(b.rating) - Number(a.rating))
            .map(({ userId, ...review }, i) => (
              <Review key={`${userId}-${i}`} data={review} />
            ))
        )}
      </ReviewContainerEl>
    </ComponentLoader>
  )
}

export default ReviewList
